import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from '@atlassian/help-center-common-component/with-async';

export const ForgeFooterModule = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "portal-forge-ui-footer" */ './portal-footer')),
    LoadingSkeleton: () => null,
});
